import React, { useState, useEffect } from 'react';
import './EditServiceSubunitDialog.css';

const EditServiceSubunitDialog = ({ subunit, onClose, onEdit }) => {
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    nameEn: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (subunit) {
      setFormData({
        id: subunit.id || '',
        name: subunit.name || '',
        nameEn: subunit.nameEn || ''
      });
    }
  }, [subunit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim() || !formData.nameEn.trim()) {
      setError('Both Bengali and English names are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onEdit(subunit._id, formData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  if (!subunit) return null;

  return (
    <div className="dialog-overlay" onClick={handleClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>Edit Service Subunit</h3>
          <button 
            className="close-button" 
            onClick={handleClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="dialog-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="id">Subunit ID *</label>
            <input
              type="number"
              id="id"
              name="id"
              value={formData.id}
              onChange={handleInputChange}
              placeholder="Enter subunit ID"
              required
              disabled={loading}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="name">Bengali Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter Bengali name"
              required
              disabled={loading}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="nameEn">English Name *</label>
            <input
              type="text"
              id="nameEn"
              name="nameEn"
              value={formData.nameEn}
              onChange={handleInputChange}
              placeholder="Enter English name"
              required
              disabled={loading}
              className="form-input"
            />
          </div>

          <div className="dialog-actions">
            <button
              type="button"
              onClick={handleClose}
              className="cancel-button"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading || !formData.name.trim() || !formData.nameEn.trim()}
            >
              {loading ? 'Updating...' : 'Update Subunit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditServiceSubunitDialog;
